import React, { FC } from 'react';
import { Box, keyframes, Typography } from '@mui/material';
import { cyan } from '@mui/material/colors';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import { fadeIn } from 'react-animations';
import { Discount } from '@mui/icons-material';

const fadeInAnimation = keyframes`${fadeIn}`;

interface Props {
  title: string;
  description: string;
  text: string;
  services: { name: string; bullets: string[] }[];
  conclusion: string;
  darkTheme: boolean;
}

const Package: FC<Props> = ({ title, description, text, services, conclusion, darkTheme }) => (
  <Box
    sx={{
      p: 3,
      height: '100%',
      background: darkTheme ? cyan[800] : cyan[300],
      color: darkTheme ? 'white' : '',
      boxShadow: ' rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
      animation: `500ms ${fadeInAnimation}`,
    }}
  >
    <Typography variant="h5" sx={{ fontWeight: 'bold', color: darkTheme ? 'white' : '' }}>
      {title}
    </Typography>
    <Typography sx={{ mt: 1, color: darkTheme ? 'white' : '', fontWeight: 'bold' }}>{description}</Typography>
    <Typography sx={{ mt: 1, mb: 2, color: darkTheme ? 'white' : '' }}>{text}</Typography>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, m: 1 }}>
      <Discount />
      <Typography sx={{ color: darkTheme ? 'white' : '', fontWeight: 'bold' }}>
        20% popusta na sve medicinske usluge
      </Typography>
    </Box>
    {services.map((service) => (
      <Box sx={{ mt: 3 }}>
        <Typography sx={{ color: darkTheme ? 'white' : '', fontSize: '14px', fontWeight: 'bold', mb: 1 }}>
          {service.name}
        </Typography>
        {service.bullets.map((bullet) => {
          return (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
              <CheckCircleRoundedIcon fontSize="small" />
              <Typography sx={{ color: darkTheme ? 'white' : '', fontSize: '14px' }}>{bullet}</Typography>
            </Box>
          );
        })}
      </Box>
    ))}
    <Typography sx={{ pt: 3, color: darkTheme ? 'white' : '', fontWeight: 'bold' }}>{conclusion}</Typography>
  </Box>
);

export default Package;
